import {AssistantError} from './AssistantError.js'

export class NotFoundAssistantError extends AssistantError {
  static create(message) {
    return new NotFoundAssistantError(message)
  }
}
